import React from 'react';
import { Modal } from 'react-bootstrap';
import Button from '../form/button';

function ConfirmarExclusaoModal({
  show,
  titulo = 'Confirmar exclusão',
  mensagem,
  itemNome,
  detalhe,
  confirmando = false,
  onConfirm,
  onCancel,
  confirmarLabel = 'Excluir',
}) {
  return (
    <Modal show={show} onHide={onCancel} backdrop="static" dialogClassName="os-excel-modal-dialog">
      <div className="os-excel-modal-shell">
        <div className="os-excel-modal-header">
          <div className="os-excel-modal-header-main">
            <div className="os-excel-modal-header-icon confirmar-exclusao-modal-icon">
              <i className="fa fa-trash-alt" />
            </div>
            <div>
              <h4>{titulo}</h4>
              <p>{mensagem || 'Esta ação não pode ser desfeita.'}</p>
            </div>
          </div>
          <button type="button" className="os-excel-modal-close" onClick={onCancel} aria-label="Fechar">
            <i className="fa fa-times" />
          </button>
        </div>

        <div className="os-excel-modal-body confirmar-exclusao-modal-body">
          {itemNome ? (
            <div className="confirmar-exclusao-item-resumo">
              <span className="confirmar-exclusao-item-nome">{itemNome}</span>
              {detalhe ? <span className="confirmar-exclusao-item-detalhe">{detalhe}</span> : null}
            </div>
          ) : null}
          <p className="confirmar-exclusao-aviso">
            <i className="fa fa-exclamation-triangle" /> O registro será removido permanentemente do sistema.
          </p>
        </div>

        <div className="os-excel-modal-footer">
          <Button
            type="button"
            className="default"
            icon="close"
            label="Cancelar"
            onClick={onCancel}
            disabled={confirmando}
          />
          <button
            type="button"
            className="btn btn-danger os-excel-modal-action-btn"
            onClick={onConfirm}
            disabled={confirmando}
          >
            {confirmando ? (
              <>
                <i className="fa fa-spinner fa-spin" /> Excluindo...
              </>
            ) : (
              <>
                <i className="fa fa-trash-alt" /> {confirmarLabel}
              </>
            )}
          </button>
        </div>
      </div>
    </Modal>
  );
}

export default ConfirmarExclusaoModal;
